import {IconMap, IconName, IconPath} from '@app/shared/common/icons';
import {FullAuditedAggregateRoot} from '@models/shared/FullAuditedAggregateRoot';

export class AppointmentType extends FullAuditedAggregateRoot {
  name: string;
  isActive: boolean;

  static mapToIcon(name: string): IconPath {
    const mappedName = AppointmentType.nameToNormalised(name);

    switch (mappedName) {
      case 'video-call':
        return IconMap.cameraVideo;
      case 'audio-call':
        return IconMap.phone;
      case 'voice-call':
        return IconMap.phone;
      case 'face-to-face':
        return IconMap.location;
    }

    throw Error(`No icon found for this string! "${name}" => "${mappedName}"`);
  }

  static nameToNormalised(name: string): string {
    return name.replace(/\s+/g, '-').toLowerCase();
  }
}
